export enum UserTypes {
  SET_AUTH_STATUS = 'SET_AUTH_STATUS',
  LOGOUT = 'LOGOUT'
}